export const baseUrl = `https://${process.env.REACT_APP_GATEWAY_BASE_URL}`

export const axiosDefaultHeader = {
  'Content-Type': 'application/json;charset=UTF-8',
  Accept: 'application/json',
}

export const axiosDownloadHeader = {
  'Content-Type': 'application/zip;charset=UTF-8',
  Accept: 'application/octet-stream',
}

export const stage = `/${process.env.REACT_APP_STAGE}`

export const apiUrl = {
  tenantsPath: '/tenants/',
  authPath: '/auth',
  usersPath: '/users/',
  devicesPath: '/devices/',
  phrasesPath: '/phrases/',
  conversionsPath: '/conversions/',
  wordsPath: '/words/',
  illustrationsPath: '/illustrations/',
  logosPath: '/logos/',
  signagesPath: '/signages/',
  conversationsPath: '/conversations/',
  conversationsLogPath: '/conversation-logs/',
  signedUrlPath: '/signedurl/',
  emailPath: '/email/',
  versionPath: '/version/',
  rhqInfoPath: '/rhqinfo/',
  subtenantDevicesPath: '/subtenant-devices/',
}
